import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from '../../store/slices/auth-slice';
import { Roles } from '../consts/roles';

function PublicRoute() {
  const loggedInUser = useSelector(selectLoggedInUser);

  let path = '';
  if (loggedInUser) {
    switch (loggedInUser.role.name) {
      case Roles.ROOT:
        path = '/car-houses';
        break;
      case Roles.ADMIN:
        path = '/vehicles';
        break;
      case Roles.CARHOUSEADMIN:
        path = '/users';
        break;
      case Roles.USER:
        path = '/vehicles';
        break;
      default:
        break;
    }
  }

  return !loggedInUser ? <Outlet /> : <Navigate to={path} replace />;
}

export default PublicRoute;
